module.exports = __webpack_public_path__ + "static/img/pprocess2.5bee44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/pprocess2.png
// module id = 6AAk
// module chunks = 0